import { render, staticRenderFns } from "./Ventanilla.vue?vue&type=template&id=7cabccd8&"
import script from "./Ventanilla.vue?vue&type=script&lang=js&"
export * from "./Ventanilla.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports